import {
  Box,
  Button,
  FormControlLabel,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import { Controller, useForm } from "react-hook-form";

import { FC, useEffect } from "react";
import { Estado } from "../../../../interfaces/SuperAdmin/Others/iDataEstado";
import {
  iDataUser,
  PutUserFields,
} from "../../../../interfaces/SuperAdmin/Pages/iDataUser";

interface Props {
  isEditModalOpen: boolean;
  toggleEditModal: (isOpen: boolean) => void;
  isEditing: boolean;
  usuarioSeleccionado: iDataUser | null;
  userEdit: (id_usuario: string, data: PutUserFields) => Promise<void>;
}

const EditUserModal: FC<Props> = ({
  isEditModalOpen,
  toggleEditModal,
  isEditing,
  usuarioSeleccionado,
  userEdit,
}) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<PutUserFields>();

  // Función para manejar el envío del formulario
  const handleSubmitForm = (data: PutUserFields) => {
    if (usuarioSeleccionado) {
      userEdit(usuarioSeleccionado.id_usuario, data);
    }
  };

  useEffect(() => {
    if (usuarioSeleccionado) {
      reset({
        nombres: usuarioSeleccionado.nombres,
        apellidos: usuarioSeleccionado.apellidos,
        estado: usuarioSeleccionado.estado,
      });
    }
    console.log(usuarioSeleccionado);
  }, [usuarioSeleccionado]);

  return (
    <Modal
      open={isEditModalOpen}
      onClose={() => toggleEditModal(false)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <Typography
          id="edit-subscription-modal-title"
          variant="h6"
          component="h2"
        >
          Editar usuario
        </Typography>

        {/* Campo Nombre */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Nombres
          </Typography>
          <Controller
            name="nombres"
            control={control}
            rules={{ required: "El nombre es obligatorio" }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                margin="normal"
                error={!!errors.nombres}
                helperText={errors.nombres?.message}
                disabled={isEditing}
              />
            )}
          />
        </Box>

        {/* Campo Apellidos */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Apellidos
          </Typography>
          <Controller
            name="apellidos"
            control={control}
            rules={{ required: "El apellido es obligatorio" }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                margin="normal"
                error={!!errors.apellidos}
                helperText={errors.apellidos?.message}
                disabled={isEditing}
              />
            )}
          />
        </Box>

        {/* Switch de Estado */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ mt: 3, fontWeight: 500 }}>
            Estado
          </Typography>
          <Controller
            name="estado"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Switch
                    {...field}
                    checked={field.value === Estado.ACTIVO}
                    onChange={(e) =>
                      field.onChange(
                        e.target.checked ? Estado.ACTIVO : Estado.INACTIVO
                      )
                    }
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#2E7D32",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                        {
                          backgroundColor: "#2E7D32",
                        },
                    }}
                  />
                }
                label={field.value === Estado.ACTIVO ? "Activo" : "Inactivo"}
              />
            )}
          />
        </Box>

        <Box sx={{ mt: 3, textAlign: "right" }}>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isEditing}
            type="submit"
          >
            {isEditing ? "Guardando" : "Guardar"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditUserModal;
